export const environment = {
  production: false,
  version: '1.0',
  disableAuthGuard: true, // Desactivar guards en desarrollo
  environment: 'DEV',
  BASE_URL: 'https://9ppwzuovvb.execute-api.us-east-1.amazonaws.com/prod',
  AI_URL: 'https://api.qa.sipadmi.com/extractor',
  AI_API_KEY: 'L8DrM6jVew9XHN3YUPsadfAuKFBtR7pE5WgcCvhZ4b',
  // URLs del Orquestador
  orchestratorApiUrl: 'http://localhost:3001/api',
  orchestratorWebSocketUrl: 'ws://localhost:3001',
  websocketUrl: 'ws://localhost:3001/ws', // URL específica para WebSocket de detalle de pago
  cognito: {
    userPoolWebClientId: '1iffm3u035g69slej84ljd4ebt',
    userPoolId: 'us-east-1_w3kNxdtfa',
  },
};
